import dayjs from "dayjs";

function dayJS(input?: string): dayjs.Dayjs {
    const isDateTime = input && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?$/.test(input);
    return isDateTime ? dayjs(`${input}Z`) : dayjs(input);
}

export default dayJS;
